const React = require('react');
const ReactIntl = require('react-intl');
const { partial } = require('lodash');
const { Button } = require('metro-ui-components');
const defaultMessages = require('../../i18n/messages/default');
const LoginPreferencesCardWrapper = require('./LoginPreferencesCardWrapper');
const LoginActions = require('../../actions/LoginActions');
const LoginStore = require('../../stores/LoginStore');
const AppConstants = require('../../constants/AppConstants');
const AuthMethodsModal = require('./AuthMethodsModal');
const CodesViaSmsModal = require('./CodesViaSmsModal');
const SetupCodeViaAppModal = require('./SetupCodesViaAppModal');
const SecurityDeviceModal = require('./SecurityDeviceModal');
const TwoFactorAuthenticationMethodsList = require('../TwoFactorAuthenticationMethodsList/TwoFactorAuthenticationMethodsList');

const { injectIntl } = ReactIntl;

class LoginPreferencesV2 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      authMethod: '',
      selectedValue: '',
      mfaOptionType: '',
      toastrMessage: '',
      toastrType: 'success',
      authMethodsModalVisible: false,
      smsModalVisible: false,
      codeModalVisible: false,
      securityDeviceModalVisible: false,
      uAuthenticationMethod: this.props.userAuthenticationMethod,
      twoFactorAuthInfo: {},
      userMFAMethods: [],
    };

    this.onSelectionChange = this.onSelectionChange.bind(this);
    this.toggleModalVisible = this.toggleModalVisible.bind(this);
    this._setUserMFAOptionType = this._setUserMFAOptionType.bind(this);
    this.deleteAuthenticationMethod = this.deleteAuthenticationMethod.bind(this);
    this.onDeleteMFAMethodListener = this.onDeleteMFAMethodListener.bind(this);
    this.onAddGetUserMfa = this.onAddGetUserMfa.bind(this);
  }

  componentDidMount() {
    LoginActions.getTwoFATempSecret(this.props.idToken, this.props.userType, this.props.traceId);
    LoginActions.getUserMFAMethods(this.props.idToken, this.props.countryCode);
    LoginStore.addGetUserMFAOptions(this.onAddGetUserMfa);
    LoginStore.addDeleteUserMFAMethodListener(this.onDeleteMFAMethodListener);
    this.onAddGetUserMfa();
    const userState = this.getUserCurrentState(this.props.userAuthenticationMethod);
    if(userState){
      LoginActions.triggerToast(userState.toastrMessage,userState.toastrType);
    }
  }

  onAddGetUserMfa() {
    const state = LoginStore.getState();
    this.setState({ userMFAMethods: state.userMFAMethods }, () => {
      this._setUserMFAOptionType();
    })
  }

  componentWillUnmount() {
    LoginStore.removeDeleteUserMFAMethodListener(this.onDeleteMFAMethodListener)
  }

  _setUserMFAOptionType() {
    const { userMFAMethods } = this.state;
    userMFAMethods.forEach((mfaMethod) => {
      if (mfaMethod.isDefault) {
        this.setState({ mfaOptionType: mfaMethod.mfaOptionType })
      }
    })
  }

  getUserCurrentState(authenticationMethod) {
    const { userType } = this.props;
    const { userMFAMethods } = this.state;
    if (authenticationMethod === AppConstants.TWO_FA_TOTP_APP && !!userMFAMethods.length) {
      return {
        toastrMessage: this.props.intl.formatMessage(defaultMessages['loginpreferences.2fa.status_ok']),
        toastrType: 'success',
        selectedValue: 'otpGeneratorApp'
      };
    } else if (authenticationMethod === AppConstants.TWO_FA_TOTP  && !!userMFAMethods.length) {
      return {
        toastrMessage: this.props.intl.formatMessage(defaultMessages['loginpreferences.2fa.status_ok']),
        toastrType: 'success',
        selectedValue: 'otpViaSms'
      };
    } else if (authenticationMethod === AppConstants.TWO_FA_WEB_AUTHN  && !!userMFAMethods.length) {
      return {
        toastrMessage: this.props.intl.formatMessage(defaultMessages['loginpreferences.2fa.status_ok']),
        toastrType: 'success',
        selectedValue: 'optViaFingerprint'
      };
    } else if (authenticationMethod === AppConstants.LoginPreferences.AUTH_METHOD_USER_CREDENTIAL
      && userType === 'SUPP') {
      return {
        toastrMessage: this.props.intl.formatMessage(defaultMessages['loginpreferences.2fa.status_error_no_2fa']),
        toastrType: 'error',
        selectedValue: ''
      };
    } else if (authenticationMethod === AppConstants.LoginPreferences.AUTH_METHOD_USER_CREDENTIAL
      && userType !== 'SUPP') {
      return {
        toastrMessage: this.props.intl.formatMessage(defaultMessages['loginpreferences.2fa.status_warning']),
        toastrType: 'warning',
        selectedValue: ''
      };
    } else {
      return {
        toastrMessage: this.props.intl.formatMessage(defaultMessages['loginpreferences.2fa.status_error_no_2fa']),
        toastrType: 'error',
        selectedValue: ''
      };
    }
  }

  onSelectionChange(value) {
    this.goToSelectedAuthMethod(value);
  }

  goToSelectedAuthMethod(value) {
    switch (value) {
      case 'otpGeneratorApp':
        LoginActions.getTwoFATempSecret(this.props.idToken, this.props.userType, this.props.traceId);
        this.setState({
          selectedValue: value,
          codeModalVisible: true,
          authMethodsModalVisible: false,
          authMethod: AppConstants.LoginPreferences.TWO_FA_TOTP_APP_OPTION_MAP
          });
        break;
      case 'otpViaSms':
        LoginActions.getTwoFATempSecret(this.props.idToken, this.props.userType, this.props.traceId);
        this.setState({
          selectedValue: value,
          smsModalVisible: true,
          authMethodsModalVisible: false,
          authMethod: AppConstants.LoginPreferences.TWO_FA_TOTP_SMS_OPTION_MAP
        });
        break;
      case 'optViaFingerprint':
        this.setState({
          selectedValue: value,
          securityDeviceModalVisible: true,
          authMethodsModalVisible: false,
          authMethod: AppConstants.LoginPreferences.TWO_FA_WEB_AUTHN_OPTION_MAP
        });
        break;
      case 'authMethods':
        this.setState({
          selectedValue: '',
          smsModalVisible: false,
          codeModalVisible: false,
          securityDeviceModalVisible: false,
          authMethodsModalVisible: true,
          authMethod: ''
        });
        break;
      default:
        this.setState({ selectedValue: '', authMethod: '' });
        break;
    }
  }

  toggleModalVisible(field) {
    this.setState({ [field]: !this.state[field] });
  }

  onDeleteMFAMethodListener() {
    const { userMFAMethods } = this.state;
    const appState = LoginStore.getState();

    const userMFAMethodsFiltered = userMFAMethods.filter((method) => method.credentialId !== appState.deleteUserMFA.userMFAMethodId)
    this.setState({ userMFAMethods: userMFAMethodsFiltered })
  }

  deleteAuthenticationMethod(credentialId, userId) {
    LoginActions.deleteUserMFAMethod(this.props.idToken, userId, this.props.userType, credentialId, this.props.countryCode);
  }

  render() {
    const { userMFAMethods } = this.state;
    const { userAuthenticationMethod, intl, idToken, userId, userType } = this.props;
    const userState = this.getUserCurrentState(userAuthenticationMethod);

    return (
      <>
        <LoginPreferencesCardWrapper headingText={intl.formatMessage(defaultMessages['loginpreferences.2fa'])}>
          <div className="row">
            <div className="col-md-6 col-md-offset-3 col-sm-6 col-sm-offset-3 col-xs-12">
              <Button
                id="addNew2FAMethod"
                type="button"
                kind="primaryRaised"
                className="submit-btn"
                size="large"
                value="submit"
                onClick={partial(this.toggleModalVisible, 'authMethodsModalVisible')}
                block
              >
                {intl.formatMessage(defaultMessages['loginpreferences.2fa.add_new_2fa_method'])}
              </Button>
            </div>
            <div className="col-md-12 col-sm-12 col-xs-12">
              <TwoFactorAuthenticationMethodsList
                deleteAuthenticationMethod={this.deleteAuthenticationMethod}
                userMFAMethods={userMFAMethods}
                tokenId={idToken}
                userId={userId}
                userType={userType}
              />
            </div>
          </div>
        </LoginPreferencesCardWrapper>
        {this.state.authMethodsModalVisible &&
          <AuthMethodsModal
            closeModal={partial(this.toggleModalVisible, 'authMethodsModalVisible')}
            mfaOptions={this.props.mfaOptions}
            onSelectionChange={this.onSelectionChange}
            userState={userState}
            authMethod={this.state.authMethod}
            {...this.props}
          />}
        {this.state.smsModalVisible &&
          <CodesViaSmsModal
            onBackNavigationClick={partial(this.onSelectionChange, 'authMethods')}
            closeModal={partial(this.toggleModalVisible, 'smsModalVisible')}
            authMethod={this.state.authMethod}
            {...this.props}
          />
        }
        {this.state.codeModalVisible &&
          <SetupCodeViaAppModal
            twoFactorAuthInfo={this.state.twoFactorAuthInfo}
            onBackNavigationClick={partial(this.onSelectionChange, 'authMethods')}
            closeModal={partial(this.toggleModalVisible, 'codeModalVisible')}
            authMethod={this.state.authMethod}
            {...this.props}
          />
        }
        {this.state.securityDeviceModalVisible &&
          <SecurityDeviceModal
            onBackNavigationClick={partial(this.onSelectionChange, 'authMethods')}
            closeModal={partial(this.toggleModalVisible, 'securityDeviceModalVisible')}
            authMethod={this.state.authMethod}
            {...this.props}
          />
        }
      </>
    );
  }
}

module.exports = injectIntl(LoginPreferencesV2);
